export const QuizSliderCloseButton = ({ onClose }) => {
    return (
        <div className="absolute -top-12 right-4">
            <button
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md"
                onClick={onClose}
                aria-label="Close"
            >
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13 13M1 13L13 1" stroke="black" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </button>
        </div>
    )
}